import React from 'react';
import clsx from 'clsx';

import scss from './EmptyState.module.scss';

function EmptyState({ icon, title, description, action, className, bordered = true, accentIcon = false }) {
  return (
    <div className={clsx(scss.root, bordered && scss.bordered, className)}>
      {icon ? <div className={clsx(scss.icon, accentIcon && scss.iconAccent)}>{icon}</div> : null}
      {title ? <span className={scss.title}>{title}</span> : null}
      {description ? <span className={scss.description}>{description}</span> : null}
      {action ? <div className={scss.action}>{action}</div> : null}
    </div>
  );
}

export default EmptyState;
